import { useKFlags } from '@/hooks/use-k-flags';
import { Flex, Text, Icon } from '@chakra-ui/react';
import { BsArrowRight } from 'react-icons/bs';

export const PassthroughValue = ({ value = 0, row = {} }) => {
  const { ats_enabled } = useKFlags();

  const getColorByValue = (val) => {
    if (val > 50) return '#00A91B';
    if (val >= 25) return '#FF9900';
    return '#FF0000';
  };

  const color = getColorByValue(value);
  const displayValue = value > 100 ? 100 : value;

  return (
    <Flex gap="5px">
      <Text
        color={color}
        fontSize="14px"
        fontWeight={row.canExpand && row.depth === 0 ? '650' : '550'}
        textAlign={ats_enabled ? 'start' : undefined}
      >
        {displayValue}%
      </Text>
      <Icon as={BsArrowRight} width="20px" height="20px" color={color} />
    </Flex>
  );
};
